/* global L */

import { renderToString } from "react-dom/server";

export const createMapMarkerClusterIcon = cluster => {
  const markers = cluster.getAllChildMarkers();
  if (!markers.length) return "";

  const { options } = markers[0].options.icon;

  // We parse the resulting HTML and add the cluster markers counter into its
  // content.
  //
  // Note that this only works because all of our icons have the
  // `map-element-image` class.
  //
  const { html } = options;
  const doc = new DOMParser().parseFromString(html, "text/html");
  const image = doc.querySelector(".map-element-image");
  image.innerHTML = renderToString(
    <span className="marker-cluster-children-count">{cluster.getChildCount()}</span>
  );

  return L.divIcon({
    ...options,
    html: doc.body.innerHTML
  });
};
